import { EnumTipoFacturacion } from '../../../api'
import { EnumEstadoCiclo } from '../../../api/oData/enums/enumEstadoCiclo'
import { NonAuthRoutes } from '../../../model'

export interface StatusConfig {
  i18nKey: string
  stepIndex: number
  isProcessing: boolean
  navigateTo?: string | ((additionalState?: any) => string)
}

/**
 * Resuelve el destino de navegación de un estado, soportando tanto strings estáticos
 * como funciones que toman el additionalState para determinar la ruta.
 */
export const resolveNavigateTo = (
  navigateTo: StatusConfig['navigateTo'],
  additionalState?: any
): string | undefined => {
  if (!navigateTo) return undefined
  return typeof navigateTo === 'function' ? navigateTo(additionalState) : navigateTo
}

/**
 * Configuración de estados del ciclo de facturación
 *
 * Criterio clave:
 * - Solo hay "procesamiento real" en estado Procesando
 * - El resto de los estados son estables → no requieren polling activo
 * - stepIndex se usa solo para UI (Stepper / progreso visual)
 */
export const invoiceCycleStatusConfig: Record<EnumEstadoCiclo, StatusConfig> = {
  [EnumEstadoCiclo.Iniciado]: {
    i18nKey: 'invoiceCyclesProcessingPage:status.started',
    stepIndex: 0,
    isProcessing: false
  },

  [EnumEstadoCiclo.PdteValidarListado]: {
    i18nKey: 'invoiceCyclesProcessingPage:status.pendingContractSelection',
    stepIndex: 0,
    isProcessing: false,
    navigateTo: (additionalState?: any) => {
      const isAnnulationOrRefacturation =
        additionalState?.billingType === EnumTipoFacturacion.Anuladora ||
        additionalState?.billingType === EnumTipoFacturacion.Refacturacion
      return isAnnulationOrRefacturation
        ? NonAuthRoutes.SettlementsAnnulation
        : NonAuthRoutes.Settlements
    }
  },

  [EnumEstadoCiclo.Procesando]: {
    i18nKey: 'invoiceCyclesProcessingPage:status.processing',
    stepIndex: 1,
    isProcessing: true
  },

  [EnumEstadoCiclo.PdteValidarFacturas]: {
    i18nKey: 'invoiceCyclesProcessingPage:status.pendingInvoices',
    stepIndex: 1,
    isProcessing: false,
    navigateTo: NonAuthRoutes.SettlementsInvoices
  },

  [EnumEstadoCiclo.Finalizado]: {
    i18nKey: 'invoiceCyclesProcessingPage:status.finished',
    stepIndex: 2,
    isProcessing: false,
    navigateTo: NonAuthRoutes.invoiceCycleFinished
  },

  [EnumEstadoCiclo.Anulado]: {
    i18nKey: 'invoiceCyclesProcessingPage:status.cancelled',
    stepIndex: 0,
    isProcessing: false,
    navigateTo: NonAuthRoutes.invoiceCyclesNew
  }
}
